import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import setRegex from '~/utils/setRegex';
import HandleFormData from '~/utils/HandleFormData';
import { Label, Input, Select } from '~/componentes/CustomForm';
import PreviewFileInput from '~/componentes/CustomForm/FileInput/styles/PreviewFileInput';

import { Container, CustomScrollBarCust } from './styles';
import { Materialize } from '~/styles/materializeGrid';
import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import ProdutosList from '../ProdutosList';
import AcessosList from '../AcessosList';

function CreateEditContent({ mountedData }) {
  const [produtos, setProdutos] = useState([]);
  const [file, setFile] = useState();
  const [fileExist, setFileExist] = useState();
  const [ativo, setAtivo] = useState(!mountedData ? 'true' : mountedData?.ativo ? 'true' : 'false');
  const [abaAtiva, setAbaAtiva] = useState(0);

  const abas = [{ titulo: 'Geral' }, { titulo: 'Acessos' }];

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = HandleFormData(file, {
          ...data,
          produtos,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === 'true' ? true : false,
          fileExist: fileExist,
        });
        let response;
        if (mountedData?.id)
          response = await api.put('/signed/empresa/gestorprojeto/cliente/cliente', thisData);
        else response = await api.post('/signed/empresa/gestorprojeto/cliente/cliente', thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${
            mountedData?.id ? 'atualizar' : 'cadastrar'
          } esse Cliente, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${
          mountedData?.id ? 'atualizar' : 'cadastrar'
        } esse Cliente?`,
        successModal: `Cliente ${mountedData?.id ? 'atualizado' : 'cadastrado'} com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          {abas.map((thisVal, a) => (
            <div
              key={a}
              className={abaAtiva == a ? 'item-aba ativo' : 'item-aba'}
              onClick={() => setAbaAtiva(a)}
            >
              <span></span>
              <p>{thisVal?.titulo}</p>
            </div>
          ))}
        </div>

        <div className={abaAtiva == 0 ? 'item-modal ativo' : ' item-modal'}>
          {/* <div className="row">
            <p className="h-descricao">
              Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios
            </p>
          </div> */}
          <div className="row">
            <Label title="Razão Social *" className="col s5 m5 l5">
              <Input name="razaoSocial" required="true" defaultValue={mountedData?.razaoSocial} />
            </Label>
            <Label title="Nome Fantasia *" className="col s4 m4 l4">
              <Input required="true" name="nomeFantasia" defaultValue={mountedData?.nomeFantasia} />
            </Label>
            <Label title="Cnpj/Cpf *" className="col s3 m3 l3">
              <Input
                required="true"
                name="identificacao"
                defaultValue={mountedData?.identificacao}
              />
            </Label>
          </div>
          <div className="row">
            <Label title="E-mail *" className="col s3 m3 l3">
              <Input required="true" name="email" type="email" defaultValue={mountedData?.email} />
            </Label>
            <Label title="Telefone 1 *" className="col s2 m2 l2">
              <Input name="telefone1" required="true" defaultValue={mountedData?.telefone1} />
            </Label>
            <Label title="Telefone 2 " className="col s2 m2 l2">
              <Input name="telefone2" defaultValue={mountedData?.telefone2} />
            </Label>
            <Label title="Ativo *" className="col s2 m2 l2">
              <Select
                isString
                list={{
                  list: [
                    { id: 'true', titulo: 'Sim' },
                    { id: 'false', titulo: 'Não' },
                  ],
                  value: 'id',
                  label: 'titulo',
                }}
                name="ativo"
                defaultValue={mountedData?.ativo?.toString()}
                onChange={e => {
                  const v = e.currentTarget.value || 'true';
                  setAtivo(v);
                }}
              />
            </Label>
            <div className="col s12 m12 l3">
              <Label title="Foto Logo *" className="label_preview">
                <PreviewFileInput
                  maxHeight="12.5em"
                  defaultPreview={mountedData?.arquivo?.url}
                  formFile={setFile}
                  checkPreview={setFileExist}
                />
              </Label>
            </div>
          </div>
          <div className="row">
            <Label title="Id MoviDesk" className="col s12 m6 l2">
              <Input name="idMoviDesk" defaultValue={mountedData?.idMoviDesk} />
            </Label>
            <Label title="URL API Protheus (Portal RH)" className="col s12 m6 l10">
              <Input
                name="urlApiProtheus"
                placeholder="https://protheus.cliente.com.br/rest/auth"
                defaultValue={mountedData?.urlApiProtheus}
              />
            </Label>
          </div>
          <div className="row">
            <div className="col s12 m12 l12">
              <ProdutosList setter={setProdutos} defaultData={mountedData?.produtos || []} />
            </div>
          </div>
        </div>

        <div className={abaAtiva == 1 ? 'item-modal ativo' : ' item-modal'}>
          <AcessosList idCliente={mountedData?.id} defaultData={mountedData?.acessos || []} />
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
